// Taille de page de la liste /admin/circuits (pagination côté serveur).
export const TRIP_PUBLICATIONS_PAGE_SIZE = 10;

// Statuts acceptés par QR_LIST_TRIP_PUBLICATION : TripPublicationStatusEnum du
// controller (ce sont les statuts réellement définis dans le domaine). Un statut
// absent de cette liste n'est jamais envoyé au serveur.
export const TRIP_PUBLICATION_STATUS_FILTERS = ["DRAFTS", "PUBLISHED", "ARCHIVED"];

/**
 * Variables de QR_LIST_TRIP_PUBLICATION : seul point de construction des
 * paramètres de la liste. `search` est déjà passé par useDebouncedSearch (seuil
 * et délai appliqués en amont) ; `status` n'existe dans l'objet que lorsqu'il
 * doit être envoyé (« Tous » n'envoie pas de statut).
 */
export const buildTripPublicationsListVariables = ({
  currentPage = 0,
  search,
  status,
  establishmentIds,
}) => {
  const variables = {
    paginationParams: { currentPage, sizePage: TRIP_PUBLICATIONS_PAGE_SIZE },
    establishmentIds,
  };
  if (search) variables.search = search;
  if (TRIP_PUBLICATION_STATUS_FILTERS.includes(status)) variables.status = status;
  return variables;
};
